import { FC, useRef, useEffect, useCallback } from "react"
import classNames from "classnames"

// components
import { Icon } from "../Icon/Icon"

// icons
import { ArrowLeftIcon } from "@eventbrite/marmalade"

// styles
import * as styles from "./TakeOver.module.scss"

export type Props = {
  toggleTakeOver: () => void
  isSearchTakeOverOpen: boolean
  children: React.ReactNode
  className?: string
  headerTitle?: string
  rightSideHeaderComponent?: React.ReactNode
}

const {
  container,
  innerContainer,
  header,
  leftArrow,
  containerClosed,
  containerOpen
} = styles

export const TakeOver: FC<Props> = ({
  className,
  toggleTakeOver,
  isSearchTakeOverOpen,
  children,
  headerTitle,
  rightSideHeaderComponent
}) => {
  const ref = useRef<HTMLInputElement>(null)

  const handleEsc = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape" && isSearchTakeOverOpen) {
        toggleTakeOver()
      }
    },
    [isSearchTakeOverOpen]
  )

  // onMount
  useEffect(() => {
    if (isSearchTakeOverOpen && ref?.current) {
      ref.current.focus()
    }
  }, [isSearchTakeOverOpen])

  useEffect(() => {
    window?.addEventListener("keydown", handleEsc)

    return () => {
      window?.removeEventListener("keydown", handleEsc)
    }
  })

  return (
    <div
      className={classNames(container, className, {
        [`${containerClosed}`]: !isSearchTakeOverOpen,
        [`${containerOpen}`]: isSearchTakeOverOpen
      })}
    >
      <div className={header}>
        <div className={styles.innerHeaderContainer}>
          <Icon
            icon={<ArrowLeftIcon size="medium" />}
            className={leftArrow}
            iconProps={{ onClick: toggleTakeOver }}
          />

          {headerTitle ? (
            <p className={styles?.headerTitle}>{headerTitle}</p>
          ) : null}

          <div className={styles.rightSideHeaderComponent}>
            {rightSideHeaderComponent}
          </div>
        </div>
      </div>

      <div className={innerContainer}>{children}</div>
    </div>
  )
}
